import { useConstant } from '@visiba/react-std';
import { Timer } from '@visiba/std';
import { Fragment, ReactNode, useEffect, useState } from 'react';

interface Props {
	delay?: number;
	children: ReactNode;
}

export function DelayedRender({ delay = 250, children }: Props): JSX.Element | null {
	const [shouldRender, setShouldRender] = useState(false);
	const timer = useConstant(() => new Timer());

	useEffect(
		function whenMounted() {
			return timer.wait(() => setShouldRender(true), delay);
		},
		[timer, delay],
	);

	if (!shouldRender) {
		return null;
	}

	return <Fragment>{children}</Fragment>;
}
